import { render } from "./SharedShioriView.vue?vue&type=template&id=17bb3e14&scoped=true"
import script from "./SharedShioriView.vue?vue&type=script&lang=js"
export * from "./SharedShioriView.vue?vue&type=script&lang=js"

import "./SharedShioriView.vue?vue&type=style&index=0&id=17bb3e14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bb3e14"]])

export default __exports__